
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { HealthLifestyle } from '../../model';

export const ADD_INITIALQUESTION_RESULT = '[INITIALQUESTION] Add';
export const REMOVE_INITIALQUESTION_RESULT = '[INITIALQUESTION] Remove';


export class AddInitialQuestionResult implements Action {
    readonly type = ADD_INITIALQUESTION_RESULT;

    constructor(public payload: HealthLifestyle) { }
}
// RemovePersonalDetails
export class RemoveInitialQuestionResult implements Action {
    readonly type = REMOVE_INITIALQUESTION_RESULT;

    constructor(public payload: number) { }
}

export type Actions = AddInitialQuestionResult | RemoveInitialQuestionResult;
